// Modules
import Common from "./modules/common";
import Animate from "./modules/animate";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";

// Autoload modules
const modules = [Common, Animate, Header, Lightbox];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import singlePost from "./partials/single-post";
import singleProduct from "./partials/single-product";
import templateHome from "./partials/template-home";
import templateProducts from "./partials/template-products";
import templateContacts from "./partials/template-contacts";

// Populate Router instance with DOM routes
const routes = new Router({
  singlePost,
  singleProduct,
  templateHome,
  templateProducts,
  templateContacts,
});

// Load Events
$(document).ready(() => routes.loadEvents());
